import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Badge } from '../ui';

export const SliderInput = ({ label, val, set, min, max, unit, tooltip, required, disabled }) => {
  const displayValue = val ?? '';
  const sliderValue = val ?? min;

  return (
    <div>
      <div className="flex justify-between text-sm mb-3">
        <div className="flex items-center gap-2 text-zinc-400 font-medium">
          {label}
          {required && <Badge variant="neutral" size="xs" className="ml-1">REQ</Badge>}
          {tooltip && (
            <span title={tooltip} className="inline-flex">
              <HelpCircle size={12} className="cursor-help text-zinc-600 hover:text-zinc-400" />
            </span>
          )}
        </div>
        <div className="flex items-center gap-1">
          <input
            type="number"
            value={displayValue}
            onChange={(e) => {
              const value = e.target.value === '' ? null : parseFloat(e.target.value);
              set(value);
            }}
            disabled={disabled}
            placeholder={disabled ? 'Auto' : ''}
            className="w-16 bg-zinc-950 border border-zinc-800 rounded text-right px-1 text-white text-xs disabled:opacity-50 disabled:cursor-not-allowed"
          />
          <span className="text-zinc-600 text-xs w-6">{unit}</span>
        </div>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        value={sliderValue}
        onChange={(e) => set(Number(e.target.value))}
        disabled={disabled}
        className="w-full h-2 bg-zinc-800 rounded-lg appearance-none cursor-pointer accent-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
      />
    </div>
  );
};
